import { Link, Outlet } from "react-router-dom";
import { waContacts } from "@/lib/format";
import { Instagram, MapPin, MessageCircle, Clock } from "lucide-react";
import Header, { MobileTabBar } from "@/components/site/Header";
import { useSettings } from "@/lib/shop";

function Footer() {
  const s = useSettings();
  const links = [
    ["/katalog", "Semua Produk"], ["/koleksi-titipan", "Koleksi Titipan"], ["/pre-order", "Pre-Order Corner"], ["/promo", "Promo"], ["/panduan", "Panduan Pemesanan"], ["/lacak-pesanan", "Lacak Pesanan"],
    ["/tentang", "Tentang Kami"], ["/kontak", "Kontak & Lokasi"], ["/kebijakan-privasi", "Kebijakan Privasi"],
    ["/syarat-ketentuan", "Syarat & Ketentuan"], ["/kebijakan-pengiriman", "Pengiriman & Pembatalan"],
  ];
  return (
    <footer className="bg-neutral-900 text-neutral-300 mt-16 print:hidden" data-testid="site-footer">
      <div className="h-3 bg-[var(--bk-yellow)] stripes" />
      <div className="container-x py-12 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-4">
          <img src="/brand/logo-sm.webp" alt="Bengkel Toys & Hobbies" className="h-24 w-auto" loading="lazy" />
          <p className="mt-4 font-display text-[var(--bk-yellow)] text-lg">{s.tagline || "Your Hobby, Your Story."}</p>
          <p className="text-sm mt-2 text-neutral-400">Toko mainan & perlengkapan hobi di Pontianak, Kalimantan Barat.</p>
        </div>
        <div className="md:col-span-4 space-y-3 text-sm">
          <h3 className="text-white font-bold text-base mb-1">Hubungi Kami</h3>
          <p className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-[var(--bk-yellow)]" />{s.address}</p>
          {waContacts(s).map((c, i) => (
            <a key={c.number} data-testid={`footer-wa-link-${i}`} href={`https://wa.me/${c.number}`} target="_blank" rel="noreferrer" className="flex gap-2 hover:text-white">
              <MessageCircle className="h-4 w-4 mt-0.5 text-[var(--bk-yellow)]" />WA {c.label}: {c.display}
            </a>
          ))}
          <a data-testid="footer-ig-link" href={`https://instagram.com/${s.instagram}`} target="_blank" rel="noreferrer" className="flex gap-2 hover:text-white">
            <Instagram className="h-4 w-4 mt-0.5 text-[var(--bk-yellow)]" />@{s.instagram}
          </a>
          <div className="flex gap-2">
            <Clock className="h-4 w-4 mt-0.5 shrink-0 text-[var(--bk-yellow)]" />
            <div data-testid="footer-hours">
              {(s.hours || []).map((h, i) => (
                <div key={i}><span className="text-white">{h.label}:</span> {h.value}</div>
              ))}
            </div>
          </div>
        </div>
        <div className="md:col-span-4">
          <h3 className="text-white font-bold text-base mb-3">Tautan</h3>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            {links.map(([to, l]) => (
              <li key={to}><Link to={to} className="hover:text-[var(--bk-yellow)]" data-testid={`footer-link-${to.slice(1)}`}>{l}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800 py-5 text-center text-xs text-neutral-500 pb-24 md:pb-5">
        © {new Date().getFullYear()} {s.store_name}. Pemesanan via WhatsApp dikonfirmasi manual oleh admin.
      </div>
    </footer>
  );
}

export default function SiteLayout() {
  const s = useSettings();
  return (
    <div className="min-h-screen flex flex-col bg-[#fbfaf7]">
      <div className="print:hidden"><Header /></div>
      {s.has_demo && (
        <div data-testid="demo-notice" className="print:hidden bg-fuchsia-50 border-b border-fuchsia-200 text-fuchsia-900 text-xs text-center py-1.5 px-4">
          Produk bertanda <b>DEMO</b> adalah data contoh untuk pengujian, bukan stok toko yang sebenarnya.
        </div>
      )}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <div className="print:hidden"><MobileTabBar /></div>
    </div>
  );
}
